module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "be-wrapper be-error be-error-404"
  }, [_vm._c('navbar'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "error-container"
  }, [_vm._c('div', {
    staticClass: "error-number"
  }, [_vm._v("404")]), _vm._v(" "), _vm._c('div', {
    staticClass: "error-description"
  }, [_vm._v("Whoops, something went wrong!")]), _vm._v(" "), _vm._c('div', {
    staticClass: "error-goback-text"
  }, [_vm._v("Please try again or contact us if the problem continues.")]), _vm._v(" "), _vm._c('div', {
    staticClass: "error-goback-button"
  }, [_vm._c('a', {
    staticClass: "btn btn-xl btn-primary",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Let's go home")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c1b92e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = 642
// module chunks = 1